import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sdc-app-offline-dialog',
  templateUrl: './app-offline-dialog.component.html',
  styles: [
  ]
})
export class AppOfflineDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
